
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import {
  InputGroup,
  Input,
  Select,
  Checkbox,
  DatePicker,
} from '@drawbotics/react-drylus';
import Playground from '~/components/Playground';


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


<h1>{`Input Group`}</h1>
<p>{`This component is used to group together different types of form inputs (selects, inputs, checkboxes etc.). Should not be used on its own, rather with `}<a parentName="p" {...{
        "href": "/component-kit/forms/form-group"
      }}><inlineCode parentName="a">{`FormGroup`}</inlineCode></a></p>
<pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import { InputGroup } from '@drawbotics/react-drylus';
`}</code></pre>
<p><strong parentName="p">{`Example`}</strong></p>
<Playground __position={0} __code={`<InputGroup>
  <Checkbox checked>First one</Checkbox>
  <Checkbox>Second one</Checkbox>
  <Checkbox>Third one</Checkbox>
</InputGroup>`} component={InputGroup} mdxType="Playground">
  <InputGroup mdxType="InputGroup">
    <Checkbox checked mdxType="Checkbox">First one</Checkbox>
    <Checkbox mdxType="Checkbox">Second one</Checkbox>
    <Checkbox mdxType="Checkbox">Third one</Checkbox>
  </InputGroup>
</Playground>
<p><strong parentName="p">{`NOTE`}</strong>{`: you can set `}<inlineCode parentName="p">{`valid`}</inlineCode>{` and `}<inlineCode parentName="p">{`error`}</inlineCode>{` like you would on the form elements themselves, but it is important to know that you can override the value by setting those props in each form element as well. See `}<em parentName="p">{`Address`}</em>{` example in `}<a parentName="p" {...{
        "href": "/component-kit/forms/form-group"
      }}><inlineCode parentName="a">{`FormGroup`}</inlineCode></a>{`.`}</p>
<h3>{`Examples`}</h3>
<p>{`You are not limited to only `}<inlineCode parentName="p">{`Input`}</inlineCode>{` of course, you can group any type of form element, for example inputs here:`}</p>
<p>{`Example with error`}</p>
<Playground __position={1} __code={`<InputGroup error>
  <Input value="First thing" onChange={x=>x} />
  <Input value="Second thing" onChange={x=>x} />
  <Select placeholder="Third thing..." options={[]} onChange={x=>x} value="" />
</InputGroup>`} mdxType="Playground">
  <InputGroup error mdxType="InputGroup">
    <Input value="First thing" onChange={x => x} mdxType="Input" />
    <Input value="Second thing" onChange={x => x} mdxType="Input" />
    <Select placeholder="Third thing..." options={[]} onChange={x => x} value="" mdxType="Select" />
  </InputGroup>
</Playground>
<p>{`Form elements can also be aligned horizontally`}</p>
<Playground __position={2} __code={`<InputGroup horizontal>
  <Input value="First thing" onChange={x=>x} />
  <Input value="Second thing" onChange={x=>x} />
  <Select placeholder="Third thing..." options={[]} onChange={x=>x} value="" />
</InputGroup>`} mdxType="Playground">
  <InputGroup horizontal mdxType="InputGroup">
    <Input value="First thing" onChange={x => x} mdxType="Input" />
    <Input value="Second thing" onChange={x => x} mdxType="Input" />
    <Select placeholder="Third thing..." options={[]} onChange={x => x} value="" mdxType="Select" />
  </InputGroup>
</Playground>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;